import {AutoTextSize} from "auto-text-size";
import React from "react";
import './Name.css';

function Name({card, isSmall, isHand, isBigSize, isVeryBigSize  }:any) {
    let cardName = card.name;
    let cardNameBgClass = 'cardNameBg';
    let cardNameClasses = 'cardName font-oswald-medium ';
    if (isSmall) {
        if (isHand) {
            cardNameClasses += ' cardNameBattleHand';
        } else {
            cardNameClasses += ' cardNameBattle';
        }
        cardNameBgClass = ' cardNameBgSmall';
    }

    let maxFontSize = 14;
    if (isBigSize) {
        cardNameClasses += ' cardNamePlayed';
        maxFontSize = 16;
    }

    if (isVeryBigSize) {
        cardNameClasses += ' cardNameVeryBig';
        maxFontSize = 22;
    }

    return <div className={cardNameBgClass + ' cardNameContainer cardNameBgImg-' + card.level}>
        <div className={cardNameClasses}>
            <AutoTextSize mode={'oneline'} maxFontSizePx={maxFontSize}>  {cardName} </AutoTextSize>
        </div>
    </div>
}

export default Name;